export default "__VITE_ASSET__CtkDAT3z__"